export const categoryData = [
  {
    id: 1,
    icon: "sports_esports",
    category: "GAMES",
  },
  {
    id: 2,
    icon: "kitchen",
    category: "CONSOLE",
  },
  {
    id: 3,
    icon: "headphones",
    category: "ACCESORIES",
  },
];
